import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {ButtonComponent, MODAL_DATA, ModalRef} from '@sms-ir/ui-components';

export interface ConfirmModalData {
  modalHeader: string;
  modalText: string;
  modalConfirmButton?: string;
  modalCancelButton?: string;
}

@Component({
  selector: 'app-confirm-modal',
  standalone: true,
  imports: [ButtonComponent],
  templateUrl: './confirm-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmModalComponent {
  private readonly modalRef = inject<ModalRef<boolean>>(ModalRef);
  private readonly data = inject<ConfirmModalData>(MODAL_DATA);

  readonly modalHeader = this.data.modalHeader;
  readonly modalText = this.data.modalText;
  readonly modalConfirmButton = this.data.modalConfirmButton;
  readonly modalCancelButton = this.data.modalCancelButton;

  onSubmit(): void {
    this.modalRef.close(true);
  }

  onCancel(): void {
    this.modalRef.close(false);
  }
}
